import { createStore } from 'vuex'

import Auth from '@/store/auth'
import Corporate from '@/store/corporate'
import Branch from '@/store/branch'
import User from '@/store/user'
import Level from '@/store/level'
import Member from '@/store/member'
import Merchant from '@/store/merchant'
import Product from '@/store/product'
import Pointplan from '@/store/pointplan'
import Transaction from '@/store/transaction'
import Benefit from '@/store/benefit'
import Voucher from '@/store/voucher'
import VoucherRedeem from '@/store/voucher-redeem'
import Dashboard from '@/store/dashboard'
import TransactionHistory from './client/transaction-history'
import ClientVoucher from './client/client-voucher'
import ClientDeals from './client/client-deal'
import ClientDashboard from './client/client-dashboard'
import ClientBooking from './client/client-booking'
import ClientBenefit from './client/client-benefit'
import ClientNewsletter from './client/client-newsletter'
import BranchMerchant from '@/store/branchmerchant'
import Countries from '@/store/countries'
import AccessToken from '@/store/access-token'
import Systemlog from '@/store/systemlog'
import MemberTier from '@/store/membertier'
import ShowMemberTier from '@/store/show-member-tier'
import membertierDuration from '@/store/membertier-duration'
import MemberTiering from '@/store/membertiering'
import RegisterOption from './register-option'
import PendingMembers from './pending-members'
import ReloadHome from '@/store/reloadhome'
import Publics from './public'
import Module from '@/store/module'
import Role from '@/store/role'
import ThemeCorporate from '@/store/themecorporate'
import TransactionReport from '@/store/transaction-report'
import injectPointMember from '@/store/injectpointmember'
import ApiLog from '@/store/apilog'
import TaxService from '@/store/tax-service'
import Campaign from '@/store/campaign'
import Marketing from '@/store/marketing'
import Policies from '@/store/policies'
import ConnectionApps from '@/store/connectionApps'
import CustomToken from '@/store/customToken'
import Promotion from '@/store/promotion'
import TwoFactor from '@/store/twoFactor'
import FeatureFlag from '@/store/feature-flag'
import FeatureFlagAuditLog from '@/store/feature-flag-audit-log'
import Newsletter from '@/store/newsletter'
import Extranet from '@/store/extranet'
import ExtranetBranch from '@/store/extranetBranch'
import ExtranetMerchant from '@/store/extranetMerchant'
import VoucherGift from '@/store/voucher-gift'
import createPersistedState from 'vuex-persistedstate'
import Threshold from '@/store/threshold'
import PointHistory from '@/store/pointHistory'
import MemberRegisterTracker from '@/store/member-register-tracker'
import FeatureUpsell from '@/store/feature-upsell'
import DashboardAnalytics from '@/store/dashboard-analytics'
import Network from '@/store/network'

export default createStore({
    modules: {
        network: Network,
        Auth,
        Corporate,
        Branch,
        User,
        Level,
        Member,
        Merchant,
        Pointplan,
        Transaction,
        Voucher,
        VoucherRedeem,
        Product,
        Dashboard,
        TransactionHistory,
        ClientVoucher,
        ClientDeals,
        BranchMerchant,
        ClientDashboard,
        ClientBooking,
        Countries,
        AccessToken,
        Systemlog,
        MemberTier,
        ShowMemberTier,
        membertierDuration,
        MemberTiering,
        threshold: Threshold,
        RegisterOption,
        PendingMembers,
        ReloadHome,
        Publics,
        Module,
        ClientBenefit,
        Benefit,
        Role,
        ThemeCorporate,
        TransactionReport,
        injectPointMember,
        ApiLog,
        TaxService,
        Campaign,
        Marketing,
        Policies,
        ConnectionApps,
        CustomToken,
        Promotion,
        TwoFactor,
        FeatureFlag,
        FeatureFlagAuditLog,
        Newsletter,
        ClientNewsletter,
        extranet: Extranet,
        ExtranetBranch,
        ExtranetMerchant,
        VoucherGift,
        PointHistory,
        MemberRegisterTracker,
        'feature-upsell': FeatureUpsell,
        DashboardAnalytics,
    },
    plugins: [
        createPersistedState({
            paths: ['VoucherRedeem.savedState']
        })
    ]
})
